export default __webpack_public_path__ + "static/media/marke_1.3d8f3e93.png";